import logo from '../logo.svg';
import '../App.css';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addItem, removeItem } from '../slice/slice';

function Medicine() {
  const [medicinesData, setMedicinesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [typedName, setTypedName] = useState("");

  const token = localStorage.getItem("token");
  
  const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    setLoading(true);
    getMedicinesData();
    getCategories();
    getSubcategories();
  }, []);

  useEffect(() => {
    if (selectedCategory && !selectedSubCategory) {
      getSubcategories();
      getMedicinesData(selectedCategory, 'category');
    }
    if(selectedSubCategory){
      getMedicinesData(selectedSubCategory, 'subcategory');
    }
    if(!selectedCategory && !selectedSubCategory){
      getMedicinesData()
    }
  }, [selectedCategory,selectedSubCategory]);
  async function getMedicinesData(id , type) {
     let medicine_url = `${API_URL}/medicine`;

    if (type === 'category') {
      medicine_url = `${API_URL}/medicine?categoryId=${id}`;
    } 
    else if (type === 'subcategory') {
      medicine_url = `${API_URL}/medicine?subcategoryId=${id}`;
    }
    
    let response = await fetch(medicine_url,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    response = await response.json();
    
    setMedicinesData(response.medicines);
    setTimeout(() => {
      setLoading(false);
    }, 1000)
  }

  async function getCategories() {
    let response = await fetch(`${API_URL}/category`,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    response = await response.json();
    setCategories(response.categories);
  }


  async function getSubcategories() {
    // let response = await fetch(`${API_URL}/subcategory/69b0ecbe14866a9ee3d0dcdd`,{
    let response = await fetch(`${API_URL}/subcategory/${selectedCategory}`,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    response = await response.json();
    
    setSubCategories(response.subcategories);
  }

  const filteredMedicines = medicinesData.filter(med => {
    if (typedName && !med.name.toLowerCase().includes(typedName.toLowerCase())) return false;
    return true;
  });
  const dispatch = useDispatch();

  const cartSelector = useSelector((state) => state.cart.items);
  return (
    <>
      <Helmet>
        <title>Medicine | Clinic</title>
        <meta name="description" content="Our medicine department" />
        <meta name="keywords" content="medicine, pharmacy, clinic" />
      </Helmet>
      <div className="page-title">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h1 className="heading-title">Medicine</h1>
                <p className="mb-0">
                  Odio et unde deleniti. Deserunt numquam exercitationem. Officiis quo
                  odio sint voluptas consequatur ut a odio voluptatem. Sit dolorum
                  debitis veritatis natus dolores. Quasi ratione sint. Sit quaerat
                  ipsum dolorem.
                </p>
              </div>
            </div>
          </div>
        </div>
        <nav className="breadcrumbs">
          <div className="container">
            <ol>
              <li><NavLink to="/">Home</NavLink></li>
              <li className="current">Medicine</li>
            </ol>
          </div>
        </nav>
      </div>

      <section id="doctors" className="doctors section">

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row mb-4">
            <div className="col-md-4">
              <select
                className="form-select"
                value={selectedCategory}
                onChange={(e) => {
                  setSelectedCategory(e.target.value);
                  setSelectedSubCategory("");
                }}
              >
              <option value="">All Categories</option>
              {categories.map((cat, i) => (
                <option key={i} value={cat._id}>
                  {cat.name}
                </option>
              ))}
              </select>
            </div>

            <div className="col-md-4">
              <select
                className="form-select"
                value={selectedSubCategory}
                onChange={(e) => setSelectedSubCategory(e.target.value)}
                disabled={!selectedCategory}
              >
                <option value="">All Sub Categories</option>
                {subCategories.map((sub, i) => (
                  <option key={i} value={sub._id}>{sub.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <input type='text'
                className="form-control"
                placeholder="Search medicine name..." value={typedName} onChange={(e) => setTypedName(e.target.value)} />
            </div>
          </div>

          <div className="row gy-4">
            {
              loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                  filteredMedicines && filteredMedicines.length > 0 ? (
                  filteredMedicines.map((medicine) =>
                  <div key={medicine._id} className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="100">
                    <div className="doctor-card">
                      <div className="doctor-image">
                        <img src="assets/img/capsule.jpg" alt={medicine.name} className="img-fluid" />
                      </div>
                      <div className="doctor-content">
                        <h4>{medicine.name}</h4>
                        <span className="specialty">{medicine.category}</span>
                        <div className="doctor-meta">
                          <div className="department">
                            <i className="bi bi-building"></i>
                            <span>{medicine.subcategory}</span>
                          </div>
                        </div>
                        <div className="department m-2">
                        </div>
                        <h4>₹{medicine.price}</h4>
                        {
                          cartSelector.find(cartItem => cartItem._id == medicine._id) ?
                            <button onClick={() => dispatch(removeItem(medicine))} className="remove-cart btn btn-danger">Remove From Cart</button> :
                            <button onClick={() => dispatch(addItem(medicine))} className="add-to-cart btn btn-primary">Add To Cart</button>
                        }
                      </div>
                    </div>
                  </div>
                )) :
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <span className="">Not Found any medicine...</span>
                  </div>
              )
            }
          </div>
        </div>
      </section>
    </>
  );
}

export default Medicine;
